import React from "react";
import "../../styles/dayStyles/Day11.css";


export default function Day11() {
    return (
        <div className="day-container container-color11">
            <div className="shoe-container">
                <div className="left-shoe">
                    <div className="shoe" />
                </div>

                <div className="right-shoe">
                    <div className="shoe" />
                </div>
            </div>
            <div className="floor" />
        </div>
    )
}